export const translations = {
  "de": {
    "electronics.title": "Elektronik beilegen",
    "electronics.globalHelp": "Zentral aktiviert gilt der Schritt für alle Produkte. Sonst gilt die Einstellung am Produkt.",
    "electronics.product": "Elektronik beilegen für dieses Produkt",
    "electronics.entryHelp": "Je Komponente und Elektronikcharge eine Zeile. Mengen sind optional. Bei Mengenerfassung alle Chargenmengen derselben Komponente als positive ganze Zahlen angeben. Die Vollständigkeit vor Abschluss prüfen.",
    "electronics.component": "Elektronik-Komponente",
    "electronics.lot": "Elektronik-Chargennummer",
    "electronics.quantity": "Menge (optional)",
    "electronics.add": "Weitere Elektronikcharge",
    "electronics.remove": "Zeile entfernen",
    "electronics.immutable": "Nach Abschluss unveränderlich; auch Lot-Zuordnung und QA werden gesperrt.",
    "electronics.confirm": "Alle erforderlichen Elektronik-Komponenten und Chargen sind vollständig zugeordnet und beigelegt.",
    "electronics.complete": "Arbeitsschritt abschließen",
    "electronics.details": "Elektronik-Nachweis laden",
    "electronics.missing": "Offen / Ausnahme: Elektronik-Nachweis fehlt. Versandabschluss ist gesperrt; bei bereits gemeldeten Altchargen fehlt der historische Nachweis.",
    "electronics.none": "Kein Elektronik-Nachweis erfasst.",
    "electronics.done": "Elektronik abgeschlossen",
    "electronics.notRelevant": "ohne Mengenbezug",
    "spools.title": "Spulen / Druckstart",
    "spools.unknown": "Spule unbekannt",
    "spools.noHistory": "Spulen unbekannt – kein historischer Snapshot vorhanden.",
    "spools.start": "Druckstart",
    "spools.observed": "Beobachtete Spulen",
    "spools.mapping": "Startzuordnung",
    "spools.reason.START_NOT_OBSERVED": "Der Druckstart wurde nicht beobachtet. Keine nachträgliche Spulenzuordnung.",
    "spools.reason.NO_SLOT_MAPPING": "Kein verwendeter Slot ermittelbar.",
    "spools.reason.PRINTER_STATUS_UNAVAILABLE": "Kein aktueller Druckerstatus verfügbar.",
    "spools.reason.SLOT_NOT_IDENTIFIED": "Slot leer oder nicht eindeutig erkennbar.",
    "spools.reason.NO_UNIQUE_SPOOL": "Keine eindeutige Spule im Inventar gefunden.",
    "spools.reason.INVENTORY_UNAVAILABLE": "Spuleninventar nicht erreichbar.",
    "spools.reason.AMBIGUOUS_TAG": "Mehrere Spulen mit gleichem RFID-Merkmal.",
    "spools.reason.CONFLICTING_TAGS": "RFID-Merkmale verweisen auf unterschiedliche Spulen.",
    "spools.reason.AMBIGUOUS_ASSIGNMENT": "Mehrere Spulen sind demselben Slot zugeordnet.",
    "spools.reason.CONFLICTING_ASSIGNMENT": "Slotzuordnung und RFID-Spule widersprechen sich.",
    "filaments.refresh": "Aktualisieren",
    "filaments.error.SPOOLMAN_CONFIG": "Spoolman ist nicht korrekt konfiguriert. Bitte SPOOLMAN_URL im Hub prüfen.",
    "filaments.error.SPOOLMAN_TIMEOUT": "Spoolman antwortet nicht rechtzeitig. Bitte erneut aktualisieren.",
    "filaments.error.SPOOLMAN_RESPONSE": "Spoolman liefert keine gültige Datenliste. Bitte API-Adresse und Proxy prüfen.",
    "filaments.error.SPOOLMAN_UNAVAILABLE": "Filamentdaten konnten nicht geladen werden. Bitte Spoolman-Verbindung prüfen und erneut aktualisieren.",
    "nav.dashboard": "Dashboard",
    "nav.production": "Produktion",
    "nav.shipping": "Versand",
    "nav.inventory": "Bestand",
    "nav.admin": "Verwaltung",
    "nav.notifications": "Benachrichtigungen",
    "nav.open": "Navigation öffnen",
    "nav.home": "Startseite",
    "settings.title": "Einstellungen",
    "settings.shippingTitle": "Versand-Arbeitsaufträge",
    "settings.shippingDescription": "Wähle, welche Arbeitsschritte in der Shipping-Worklist bearbeitet werden.",
    "settings.shippingQa": "QA",
    "settings.shippingQaDescription": "Druckmenge auf OK, B-Ware und NOK verteilen.",
    "settings.shippingLabel": "Label",
    "settings.shippingLabelDescription": "Label-URL anzeigen und QR-Code erzeugen.",
    "settings.shippingAtLeastOne": "Mindestens ein Arbeitsschritt muss aktiv bleiben.",
    "settings.shippingSaved": "Versand-Arbeitsschritte gespeichert.",
    "settings.shippingLoading": "Lade Versand-Einstellungen …",
    "settings.description": "Profil, Design und Benachrichtigungen verwalten.",
    "settings.profile": "Profil",
    "settings.appearance": "Design",
    "settings.notifications": "Benachrichtigungen",
    "appearance.title": "Design",
    "appearance.description": "Farben, Theme und UI-Optionen",
    "appearance.language": "Sprache",
    "appearance.languageDescription": "Wähle die Sprache der Benutzeroberfläche.",
    "language.de": "Deutsch",
    "language.en": "English",
    "login.sessionTimeout": "Deine Sitzung wurde nach 30 Minuten Inaktivität beendet.",
    "login.sessionExpired": "Deine Sitzung ist abgelaufen. Bitte melde dich erneut an.",
    "login.checking": "Sitzung wird geprüft …",
    "login.checkingSession": "Sitzung wird geprüft …",
    "login.signIn": "Mit Authentik anmelden",
    "login.oidc": "OIDC bereitgestellt durch Authentik",
    "common.show": "Anzeigen",
    "common.hide": "Ausblenden",
    "common.details": "Details",
    "common.cancel": "Abbrechen",
    "common.close": "Schließen",
    "common.delete": "Löschen",
    "common.edit": "Bearbeiten",
    "common.save": "Speichern",
    "common.saving": "Speichere …",
    "common.saved": "Gespeichert",
    "common.loading": "Lade …",
    "common.unknown": "Unbekannt",
    "common.status": "Status",
    "common.actions": "Aktionen",
    "common.allStatuses": "Alle Status",
    "common.searchOrderProduct": "Suche: Auftrag-ID, Produkt…",
    "common.noOrders": "Keine Aufträge vorhanden.",
    "common.resetFilters": "Filter zurücksetzen",
    "common.noProductionOrders": "Noch keine Produktionsaufträge vorhanden.",
    "production.title": "Produktion",
    "production.subtitle": "Produktionsaufträge & Druckaufträge",
    "production.loading": "Lade Produktionsaufträge …",
    "shipping.title": "Versand",
    "shipping.subtitle": "Worklist für QA und Label-Erzeugung",
    "shipping.loading": "Lade Versandaufträge …",
    "shipping.worklist": "Worklist",
    "shipping.worklistDescription": "Arbeitsvorrat nach Charge und nächster Aktion",
    "shipping.entries": "Einträge",
    "shipping.noMatchingLots": "Keine passenden Chargen gefunden.",
    "shipping.selectWorkItem": "Wähle links einen Auftrag oder eine Charge aus.",
    "shipping.order": "Auftrag",
    "shipping.lot": "Charge",
    "shipping.lotOf": "von",
    "shipping.lots": "Chargen",
    "shipping.openLots": "offene Chargen",
    "shipping.workflowPerLot": "Workflow je Charge",
    "shipping.hoverLots": "Chargen anzeigen",
    "shipping.printJobs": "Druckjobs",
    "shipping.quantity": "Menge",
    "shipping.printer": "Drucker",
    "shipping.printedAt": "Gedruckt am",
    "shipping.printPreparation": "Druck wird vorbereitet",
    "shipping.waitingForLot": "Wartet auf Chargenerzeugung",
    "shipping.noLotDetail": "Für diesen Auftrag ist aktuell noch keine Charge verfügbar. Die Detailansicht bleibt read-only, bis ein Druckjob gestartet wurde.",
    "shipping.noLotYet": "Noch keine Charge angelegt",
    "shipping.actionQa": "QA erforderlich",
    "shipping.actionLabel": "Label erforderlich",
    "shipping.actionOdoo": "An Odoo melden",
    "shipping.reprintLabel": "Label nachdrucken",
    "shipping.reportOdoo": "An Odoo melden",
    "shipping.adjustQa": "QA anpassen",
    "shipping.reportedToOdoo": "An Odoo gemeldet",
    "shipping.reportOdooDescription": "Melde die OK-Menge dieser Charge an einen bestehenden Odoo-Auftrag oder lege dafür einen neuen Auftrag an.",
    "shipping.charge": "Charge",
    "shipping.existingOdooOrder": "Bestehender Odoo-Produktionsauftrag",
    "shipping.noOdooOrders": "Kein passender Odoo-Auftrag gefunden",
    "shipping.createNewOdooOrder": "Neuen Odoo-Produktionsauftrag anlegen",
    "shipping.loadingOdooOrders": "Odoo-Aufträge werden geladen …",
    "shipping.noBackorderNotice": "Kein Backorder: Odoo legt für die Restmenge keinen Folgeauftrag an.",
    "shipping.actionPrinting": "Druck läuft",
    "shipping.noOpenAction": "Keine offene Aktion",
    "shipping.noAction": "Keine Aktion erforderlich",
    "shipping.step.print": "Druck",
    "shipping.step.qa": "QA",
    "shipping.step.label": "Label",
    "shipping.qualityCheck": "Qualitätsprüfung",
    "shipping.qualityCheckDescription": "Verteile die vollständige Druckmenge auf OK, B-Ware und NOK.",
    "shipping.createLabel": "Label erzeugen",
    "shipping.createLabelDescription": "Die QA ist abgeschlossen. Erzeuge jetzt die Label-URL und den QR-Code.",
    "shipping.printInProgressNotice": "Der Druck läuft. QA und Label werden nach Abschluss des Druckjobs freigeschaltet.",
    "shipping.workflowCompleteNotice": "Das Label wurde erzeugt. Alle aktuell konfigurierten Arbeitsschritte sind abgeschlossen.",
    "shipping.qaSplit": "QA-Aufteilung",
    "shipping.qaTitle": "QA",
    "shipping.size": "Größe",
    "shipping.printQuantity": "Druckmenge",
    "shipping.notes": "Notizen …",
    "shipping.finishQa": "QA abschließen",
    "shipping.sortNewest": "Zuletzt gedruckt zuerst",
    "shipping.sortOldest": "Älteste Drucke zuerst",
    "shipping.sortLot": "Chargennummer absteigend",
    "shipping.sortProduct": "Produktname A–Z",
    "shipping.statusFilter": "Status",
    "shipping.openOnly": "Nur offene",
    "shipping.labelInformation": "Label-Information",
    "shipping.search": "Auftrag, Produkt oder Charge suchen …",
    "dashboard.activePrinters": "Aktive Drucker",
    "dashboard.printerManagement": "Druckerverwaltung",
    "dashboard.production": "Produktion",
    "dashboard.openProductionOrders": "offene Produktionsaufträge",
    "dashboard.shipping": "Versand",
    "dashboard.openShippingOrders": "offene Versandaufträge",
    "dashboard.batchesToday": "Batches heute",
    "dashboard.productsInStock": "Produkte im Lager",
    "dashboard.newNotification": "Neue Benachrichtigung",
    "dashboard.productionActivity": "Produktion",
    "dashboard.shippingActivity": "Versand",
    "dashboard.batchActivity": "Batch",
    "production.newPrintJob": "Neuer Druckauftrag",
    "production.printJobs": "Druckaufträge",
    "production.startDirect": "Direkt starten",
    "production.queue": "In Queue legen",
    "production.startManual": "Manuell starten",
    "production.completeManual": "Manuell abschließen",
    "production.cancelJob": "Abbrechen",
    "production.turnPrinterOn": "Drucker einschalten",
    "production.labelReprint": "Label neu drucken",
    "shipping.completeOrder": "Auftrag abschließen",
    "shipping.startQa": "QA starten",
    "shipping.printLabel": "Label drucken",
    "shipping.startPacking": "Verpackung starten",
    "shipping.finishPacking": "Verpackung abschließen",
    "shipping.label": "Label",
    "status.CREATED": "Erfasst",
    "status.PLANNED": "Geplant",
    "status.IN_PROGRESS": "Im Druck",
    "status.PROCESSING": "In Nachbearbeitung",
    "status.DONE": "Erfüllt",
    "status.STOPPED": "Gestoppt",
    "status.PROBLEM": "Problem",
    "status.WAITING_FOR_QA": "Wartet auf QA",
    "status.QA_RUNNING": "QA läuft",
    "status.PACKING_RUNNING": "In Verpackung",
    "status.PACKING": "In Verpackung",
    "status.PACKED": "Verpackt/Abgeschlossen",
    "status.COMPLETED": "Abgeschlossen",
    "status.PRODUCED": "Produziert",
    "status.DRAFT": "Entwurf",
    "status.QUEUED": "In Queue",
    "status.PRINTING": "Im Druck",
    "status.CANCELLED": "Abgebrochen",
    "status.PRINTED": "Gedruckt",
    "status.QA_REVIEW": "QA-Prüfung",
    "status.QA_APPROVED": "QA OK",
    "status.LABEL_PRINTED": "Label gedruckt",
    "status.SCRAP": "Ausschuss",
    "status.ACTIVE": "Aktiv",
    "status.INACTIVE": "Inaktiv",
    "status.UNKNOWN": "Unbekannt",
    "common.product": "Produkt",
    "common.quantity": "Menge",
    "common.progress": "Fortschritt",
    "common.error": "Fehler",
    "common.create": "Anlegen",
    "common.choose": "Bitte wählen …",
    "common.unknownProduct": "Unbekanntes Produkt",
    "common.total": "Gesamt",
    "common.manage": "Verwalten",
    "common.remove": "Entfernen",
    "common.allProducts": "Alle Produkte",
    "common.allPrinters": "Alle Drucker",
    "common.openOnly": "Nur offene",
    "production.syncOdoo": "Odoo abrufen",
    "production.createOrder": "Produktionsauftrag erstellen",
    "production.addOrder": "+ Produktionsauftrag",
    "production.noJobs": "Noch keine Druckaufträge vorhanden.",
    "production.printFile": "Druckdatei",
    "production.multiplier": "Drucke (Multiplikator)",
    "production.addRow": "+ Weitere Zeile",
    "production.addToQueue": "Zur Warteschleife hinzufügen",
    "production.manualPrinting": "Manuell auf 'Im Druck' setzen",
    "production.objectsPrints": "Objekte / Drucke",
    "production.loadingFiles": "Lade Dateien…",
    "production.loadError": "Unbekannter Fehler beim Laden",
    "production.createError": "Fehler beim Anlegen des Auftrags: ",
    "production.createJobsError": "Fehler beim Anlegen der Druckaufträge: ",
    "production.validJobRequired": "Mindestens eine Druckjob-Zeile muss gültig sein.",
    "production.startError": "Fehler beim Starten des Druckauftrags.",
    "production.manualComment": "Kommentar zur manuellen Intervention (Pflichtfeld):",
    "production.manualStartError": "Fehler beim manuellen Starten: ",
    "production.manualCompleteError": "Fehler beim manuellen Abschließen: ",
    "production.cancelError": "Fehler beim Abbrechen des Druckauftrags.",
    "production.batchNotes": "Notizen zur Charge (optional):",
    "production.completeError": "Fehler beim Abschließen des Druckauftrags: ",
    "production.filesError": "Fehler beim Laden der Bambuddy Dateien",
    "production.bambuddyUrlMissing": "Die öffentliche Bambuddy-URL ist noch nicht eingerichtet.",
    "production.odooUnavailable": "Odoo ist nicht erreichbar oder nicht konfiguriert.",
    "production.odooImportError": "Odoo-Aufträge konnten nicht importiert werden.",
    "production.odooTitle": "Odoo Sync – Produktionsaufträge",
    "production.odooPreview": "Simulation: Die offenen Odoo-Aufträge werden nur geladen und angezeigt. Erst mit „Neue Aufträge importieren“ werden noch nicht vorhandene Aufträge im Hub angelegt; Print Jobs werden dabei nicht erstellt.",
    "production.odooLoading": "Lade offene Produktionsaufträge aus Odoo…",
    "production.odooEmpty": "Keine offenen Odoo-Produktionsaufträge gefunden.",
    "production.odooReady": "bereit zum Import",
    "production.odooProductMissing": "Kein passendes Hub-Produkt",
    "production.odooImport": "Neue Aufträge importieren",
    "shipping.loadError": "Fehler beim Laden",
    "shipping.reopenError": "QA konnte nicht erneut geöffnet werden",
    "shipping.labelError": "Label konnte nicht geladen werden",
    "shipping.templateRequired": "Bitte eine labelprint-Vorlage am Produkt oder unter Einstellungen → Versand hinterlegen.",
    "shipping.printConfirmed": "labelprint hat den Druck bestätigt. Die Charge ist als Label gedruckt markiert.",
    "shipping.printSaveError": "Druck bestätigt, aber der Hub-Status konnte nicht gespeichert werden. Bitte nur den Status erneut speichern; beim Schließen geht diese Bestätigung verloren.",
    "shipping.odooRouteMissing": "Die Versand-Odoo-Route ist im laufenden API-Dienst noch nicht geladen. Bitte den API-Container neu starten.",
    "shipping.odooLoadError": "Odoo-Aufträge konnten nicht geladen werden",
    "shipping.odooReportError": "Odoo-Meldung fehlgeschlagen",
    "shipping.enablePrinting": "Druck unter Einstellungen → Versand aktivieren. Die QR-Anzeige setzt keinen Druckstatus.",
    "shipping.wait": "Bitte warten…",
    "shipping.printed": "Gedruckt",
    "shipping.retryStatus": "Status erneut speichern",
    "shipping.workflow": "Shipping-Workflow",
    "shipping.printAction": "Etikett drucken ({copies}×)",
    "shipping.qaSum": "Summe muss exakt {expected} ergeben (aktuell {total})",
    "dashboard.cameras": "Kameras",
    "dashboard.system": "Systemstatus",
    "dashboard.containers": "Containerinformationen",
    "dashboard.containerDescription": "Laufzeitinformationen des aktiven Nordlicht-Hub-API-Containers.",
    "dashboard.environment": "Umgebung",
    "dashboard.uptime": "Laufzeit",
    "dashboard.runtime": "Runtime",
    "dashboard.service": "Service",
    "dashboard.hostname": "Hostname",
    "dashboard.version": "Version",
    "dashboard.apps": "Apps & Tools",
    "dashboard.publicUrlMissing": "Öffentliche URL noch nicht eingerichtet",
    "dashboard.activities": "Letzte Aktivitäten",
    "dashboard.noActivities": "Noch keine Aktivitäten vorhanden.",
    "dashboard.cameraUnavailable": "Kamera nicht erreichbar",
    "dashboard.now": "gerade eben",
    "dashboard.minutesAgo": "vor {count} Min.",
    "dashboard.hoursAgo": "vor {count} Std.",
    "dashboard.daysAgo": "vor {count} Tagen",
    "dashboard.cameraOpen": "{name} öffnen",
    "dashboard.databaseManagement": "Datenbankverwaltung",
    "user.anonymous": "Nicht angemeldet",
    "user.settings": "Einstellungen",
    "user.profile": "Profil verwalten",
    "user.appearance": "Design",
    "user.notifications": "Benachrichtigungen",
    "user.cameras": "Dashboard-Kameras",
    "user.login": "Login",
    "user.logout": "Logout",
    "user.menu": "User Menu",
    "login.subtitle": "Secure Production Platform",
    "session.warning": "Deine Sitzung läuft bald ab",
    "session.continue": "Weiterarbeiten",
    "session.countdown": "Automatische Abmeldung wegen Inaktivität in {time}.",
    "filters.close": "Filter schließen",
    "filters.advanced": "Erweiterte Filter",
    "filters.active": "{count} Filter aktiv",
    "view.grid": "Kachelansicht",
    "view.list": "Listenansicht",
    "version.showNotes": "Versionshinweise anzeigen",
    "production.alreadyInHub": "bereits im Hub #{id}",
    "production.jobsForOrder": "Druckaufträge für Auftrag #{id}",
    "production.objectsPerPrint": "{count} Objekte pro Druck",
    "production.fileId": "Datei {id}",
    "production.totalObjects": "Gesamt: {count} Objekte in {jobs} Druckjobs",
    "production.orderSummary": "Auftrag #{id} · Menge {quantity} · fertig {done}",
    "status.FAILED": "Fehlgeschlagen",
    "notifications.allRead": "Alle gelesen",
    "notifications.empty": "Keine neuen Benachrichtigungen",
    "notifications.open": "Notification Center öffnen",
    "settings.printTitle": "Etikettendruck mit labelprint",
    "settings.printEnable": "Desktop-Druck aktivieren",
    "settings.printUrl": "Serveradresse",
    "settings.printTemplate": "Vorlage (Pfad aus labelprint)",
    "settings.printPrinter": "Drucker (optional: Alias, Adresse oder Modell)",
    "settings.printDefault": "Standard der Vorlage / Desktop-App",
    "settings.printToken": "API-Token (nur für diese Browser-Sitzung)",
    "settings.printTokenHelp": "In labelprint unter Extras → Einstellungen die Hub-Webadresse als erlaubte Webseite eintragen und ein API-Token setzen. Das Token wird beim Speichern nur in diesem Browser-Tab hinterlegt. Server, allgemeine Vorlage und Drucker gelten für den gesamten Hub.",
    "settings.printFieldsHelp": "Vorlagenfelder: name (Produkt), groesse (Größe), qr (Chargenlink), lot (Charge), gtin und pieces (Stückzahl). Andere Vorlagenfelder bleiben unverändert. Chrome, Edge oder Firefox verwenden.",
    "settings.printReachable": "labelprint ist erreichbar. Es wurde kein Testetikett gedruckt.",
    "settings.testing": "Prüfen…",
    "settings.testConnection": "Verbindung testen",
    "settings.startDesktop": "Desktop-App starten",
    "settings.saveFailed": "Speichern fehlgeschlagen",
    "printer.activeJob": "Aktiver Job",
    "printer.noJob": "Kein aktiver Druckauftrag",
    "printer.remaining": "Verbleibend",
    "printer.end": "Ende",
    "printer.start": "Start (geschätzt)",
    "printer.nozzle": "Düse",
    "printer.bed": "Druckbett",
    "printer.days": "{count} Tage",
    "printer.today": "heute {time}",
    "printer.tomorrow": "morgen {time}",
    "dashboard.appsError": "Externe Anwendungen konnten nicht geladen werden.",
    "dashboard.spoolman": "Filamente und Spulen",
    "dashboard.bambuddy": "Drucker und Druckaufträge",
    "labelprint.invalidUrl": "Ungültige labelprint-Serveradresse",
    "labelprint.unreachable": "labelprint nicht erreichbar. Desktop-App starten, Serveradresse, erlaubte Webseite und Browserfreigabe für das lokale Netzwerk prüfen.",
    "labelprint.ambiguous": "Keine Druckbestätigung erhalten. Vor erneutem Druck den Drucker prüfen, um doppelte Etiketten zu vermeiden.",
    "labelprint.unconfirmed": "labelprint hat den Druck nicht bestätigt. Vor erneutem Druck den Drucker prüfen.",
    "labelprint.http": "labelprint meldet HTTP {status}. Token und erlaubte Webseite prüfen.",
    "shipping.invalidLabelCount": "Bitte eine positive ganze Etikettenanzahl eingeben.",
    "shipping.goodPieces": "Gutmenge der Charge",
    "shipping.labelTemplate": "Verwendete labelprint-Vorlage",
    "shipping.labelCount": "Etikettenanzahl",
    "settings.printQuantityHelp": "Die Etikettenanzahl wird aus der Gutmenge der Charge vorbelegt und kann im Druckdialog geändert werden. Eine Produktvorlage hat Vorrang vor dieser allgemeinen Vorlage.",
    "product.labelprintTemplate": "labelprint-Vorlage (optional)",
    "product.labelprintTemplatePlaceholder": "Allgemeine Vorlage aus den Versand-Einstellungen",
    "product.labelprintTemplateHelp": "Pfad aus der labelprint-Bibliothek, z. B. Ballons/Ballon Wilhelmine Gr. XL. Leer lassen, um die allgemeine Vorlage zu verwenden."
  },
  "en": {
    "electronics.title": "Include electronics",
    "electronics.globalHelp": "When enabled centrally, this step applies to all products. Otherwise the product setting applies.",
    "electronics.product": "Include electronics for this product",
    "electronics.entryHelp": "One row per component and electronics lot. Quantities are optional. If used, enter positive whole quantities for every lot of that component. Check completeness before completing.",
    "electronics.component": "Electronics component",
    "electronics.lot": "Electronics lot number",
    "electronics.quantity": "Quantity (optional)",
    "electronics.add": "Add electronics lot",
    "electronics.remove": "Remove row",
    "electronics.immutable": "Immutable after completion; lot assignment and QA will also be locked.",
    "electronics.confirm": "All required electronics components and lots are fully assigned and included.",
    "electronics.complete": "Complete work step",
    "electronics.details": "Load electronics record",
    "electronics.missing": "Pending / exception: electronics record missing. Shipping completion is blocked; previously reported legacy lots have no historical record.",
    "electronics.none": "No electronics record captured.",
    "electronics.done": "Electronics completed",
    "electronics.notRelevant": "not quantity based",
    "spools.title": "Spools / print start",
    "spools.unknown": "Unknown spool",
    "spools.noHistory": "Unknown spools – no historical snapshot available.",
    "spools.start": "Print start",
    "spools.observed": "Observed spools",
    "spools.mapping": "Start mapping",
    "spools.reason.START_NOT_OBSERVED": "Print start was not observed. No retrospective spool assignment.",
    "spools.reason.NO_SLOT_MAPPING": "No used slot could be determined.",
    "spools.reason.PRINTER_STATUS_UNAVAILABLE": "No current printer status available.",
    "spools.reason.SLOT_NOT_IDENTIFIED": "Slot empty or not uniquely identified.",
    "spools.reason.NO_UNIQUE_SPOOL": "No unique inventory spool found.",
    "spools.reason.INVENTORY_UNAVAILABLE": "Spool inventory unavailable.",
    "spools.reason.AMBIGUOUS_TAG": "Multiple spools share this RFID identifier.",
    "spools.reason.CONFLICTING_TAGS": "RFID identifiers refer to different spools.",
    "spools.reason.AMBIGUOUS_ASSIGNMENT": "Multiple spools are assigned to the same slot.",
    "spools.reason.CONFLICTING_ASSIGNMENT": "Slot assignment conflicts with the RFID spool.",
    "filaments.refresh": "Refresh",
    "filaments.error.SPOOLMAN_CONFIG": "Spoolman is not configured correctly. Please check SPOOLMAN_URL in the Hub.",
    "filaments.error.SPOOLMAN_TIMEOUT": "Spoolman did not respond in time. Please refresh to retry.",
    "filaments.error.SPOOLMAN_RESPONSE": "Spoolman did not return a valid data list. Please check the API address and proxy.",
    "filaments.error.SPOOLMAN_UNAVAILABLE": "Filament data could not be loaded. Please check the Spoolman connection and refresh to retry.",
    "nav.dashboard": "Dashboard",
    "nav.production": "Production",
    "nav.shipping": "Shipping",
    "nav.inventory": "Inventory",
    "nav.admin": "Administration",
    "nav.notifications": "Notifications",
    "nav.open": "Open navigation",
    "nav.home": "Home",
    "settings.title": "Settings",
    "settings.shippingTitle": "Shipping work steps",
    "settings.shippingDescription": "Choose which work steps are handled in the Shipping worklist.",
    "settings.shippingQa": "QA",
    "settings.shippingQaDescription": "Distribute the print quantity between OK, B-grade and NOK.",
    "settings.shippingLabel": "Label",
    "settings.shippingLabelDescription": "Show the label URL and generate the QR code.",
    "settings.shippingAtLeastOne": "At least one work step must remain active.",
    "settings.shippingSaved": "Shipping work steps saved.",
    "settings.shippingLoading": "Loading shipping settings …",
    "settings.description": "Manage your profile, appearance and notifications.",
    "settings.profile": "Profile",
    "settings.appearance": "Appearance",
    "settings.notifications": "Notifications",
    "appearance.title": "Appearance",
    "appearance.description": "Colors, theme and UI options",
    "appearance.language": "Language",
    "appearance.languageDescription": "Choose the interface language.",
    "language.de": "Deutsch",
    "language.en": "English",
    "login.sessionTimeout": "Your session ended after 30 minutes of inactivity.",
    "login.sessionExpired": "Your session has expired. Please sign in again.",
    "login.checking": "Checking session…",
    "login.checkingSession": "Checking session…",
    "login.signIn": "Sign in with Authentik",
    "login.oidc": "OIDC powered by Authentik",
    "common.show": "Show",
    "common.hide": "Hide",
    "common.details": "Details",
    "common.cancel": "Cancel",
    "common.close": "Close",
    "common.delete": "Delete",
    "common.edit": "Edit",
    "common.save": "Save",
    "common.saving": "Saving …",
    "common.saved": "Saved",
    "common.loading": "Loading …",
    "common.unknown": "Unknown",
    "common.status": "Status",
    "common.actions": "Actions",
    "common.allStatuses": "All statuses",
    "common.searchOrderProduct": "Search: order ID, product…",
    "common.noOrders": "No orders available.",
    "common.resetFilters": "Reset filters",
    "common.noProductionOrders": "No production orders available yet.",
    "production.title": "Production",
    "production.subtitle": "Production orders and print jobs",
    "production.loading": "Loading production orders …",
    "shipping.title": "Shipping",
    "shipping.subtitle": "Worklist for QA and label generation",
    "shipping.loading": "Loading shipping orders …",
    "shipping.worklist": "Worklist",
    "shipping.worklistDescription": "Work queue by charge and next action",
    "shipping.entries": "entries",
    "shipping.noMatchingLots": "No matching charges found.",
    "shipping.selectWorkItem": "Select an order or charge on the left.",
    "shipping.order": "Order",
    "shipping.lot": "Charge",
    "shipping.lotOf": "of",
    "shipping.lots": "charges",
    "shipping.openLots": "open charges",
    "shipping.workflowPerLot": "Workflow per charge",
    "shipping.hoverLots": "show charges",
    "shipping.printJobs": "Print jobs",
    "shipping.quantity": "Quantity",
    "shipping.printer": "Printer",
    "shipping.printedAt": "Printed",
    "shipping.printPreparation": "Print is being prepared",
    "shipping.waitingForLot": "Waiting for charge creation",
    "shipping.noLotDetail": "No charge is available for this order yet. The detail view remains read-only until a print job is started.",
    "shipping.noLotYet": "No charge created yet",
    "shipping.actionQa": "QA required",
    "shipping.actionLabel": "Label required",
    "shipping.actionOdoo": "Report to Odoo",
    "shipping.reprintLabel": "Reprint label",
    "shipping.reportOdoo": "Report to Odoo",
    "shipping.adjustQa": "Adjust QA",
    "shipping.reportedToOdoo": "Reported to Odoo",
    "shipping.reportOdooDescription": "Report this charge's OK quantity to an existing Odoo order or create a new order.",
    "shipping.charge": "Charge",
    "shipping.existingOdooOrder": "Existing Odoo manufacturing order",
    "shipping.noOdooOrders": "No matching Odoo order found",
    "shipping.createNewOdooOrder": "Create a new Odoo manufacturing order",
    "shipping.loadingOdooOrders": "Loading Odoo orders …",
    "shipping.noBackorderNotice": "No backorder: Odoo will not create a follow-up order for the remainder.",
    "shipping.actionPrinting": "Printing",
    "shipping.noOpenAction": "No open action",
    "shipping.noAction": "No action required",
    "shipping.step.print": "Print",
    "shipping.step.qa": "QA",
    "shipping.step.label": "Label",
    "shipping.qualityCheck": "Quality check",
    "shipping.qualityCheckDescription": "Distribute the complete print quantity between OK, B-grade and NOK.",
    "shipping.createLabel": "Create label",
    "shipping.createLabelDescription": "QA is complete. Create the label URL and QR code.",
    "shipping.printInProgressNotice": "Printing is in progress. QA and label generation become available after printing is complete.",
    "shipping.workflowCompleteNotice": "The label was created. All currently configured work steps are complete.",
    "shipping.qaSplit": "QA split",
    "shipping.qaTitle": "QA",
    "shipping.size": "Size",
    "shipping.printQuantity": "Print quantity",
    "shipping.notes": "Notes …",
    "shipping.finishQa": "Complete QA",
    "shipping.sortNewest": "Newest prints first",
    "shipping.sortOldest": "Oldest prints first",
    "shipping.sortLot": "Charge number descending",
    "shipping.sortProduct": "Product name A–Z",
    "shipping.statusFilter": "Status",
    "shipping.openOnly": "Open only",
    "shipping.labelInformation": "Label information",
    "shipping.search": "Search order, product or charge …",
    "dashboard.activePrinters": "Active printers",
    "dashboard.printerManagement": "Printer management",
    "dashboard.production": "Production",
    "dashboard.openProductionOrders": "open production orders",
    "dashboard.shipping": "Shipping",
    "dashboard.openShippingOrders": "open shipping orders",
    "dashboard.batchesToday": "Batches today",
    "dashboard.productsInStock": "products in stock",
    "dashboard.newNotification": "New notification",
    "dashboard.productionActivity": "Production",
    "dashboard.shippingActivity": "Shipping",
    "dashboard.batchActivity": "Batch",
    "production.newPrintJob": "New print job",
    "production.printJobs": "Print jobs",
    "production.startDirect": "Start directly",
    "production.queue": "Add to queue",
    "production.startManual": "Start manually",
    "production.completeManual": "Complete manually",
    "production.cancelJob": "Cancel",
    "production.turnPrinterOn": "Turn printer on",
    "production.labelReprint": "Reprint label",
    "shipping.completeOrder": "Complete order",
    "shipping.startQa": "Start QA",
    "shipping.printLabel": "Print label",
    "shipping.startPacking": "Start packing",
    "shipping.finishPacking": "Finish packing",
    "shipping.label": "Label",
    "status.CREATED": "Created",
    "status.PLANNED": "Planned",
    "status.IN_PROGRESS": "Printing",
    "status.PROCESSING": "Post-processing",
    "status.DONE": "Done",
    "status.STOPPED": "Stopped",
    "status.PROBLEM": "Problem",
    "status.WAITING_FOR_QA": "Waiting for QA",
    "status.QA_RUNNING": "QA running",
    "status.PACKING_RUNNING": "Packing",
    "status.PACKING": "Packing",
    "status.PACKED": "Packed/Completed",
    "status.COMPLETED": "Completed",
    "status.PRODUCED": "Produced",
    "status.DRAFT": "Draft",
    "status.QUEUED": "Queued",
    "status.PRINTING": "Printing",
    "status.CANCELLED": "Cancelled",
    "status.PRINTED": "Printed",
    "status.QA_REVIEW": "QA review",
    "status.QA_APPROVED": "QA approved",
    "status.LABEL_PRINTED": "Label printed",
    "status.SCRAP": "Scrap",
    "status.ACTIVE": "Active",
    "status.INACTIVE": "Inactive",
    "status.UNKNOWN": "Unknown",
    "common.product": "Product",
    "common.quantity": "Quantity",
    "common.progress": "Progress",
    "common.error": "Error",
    "common.create": "Create",
    "common.choose": "Please select …",
    "common.unknownProduct": "Unknown product",
    "common.total": "Total",
    "common.manage": "Manage",
    "common.remove": "Remove",
    "common.allProducts": "All products",
    "common.allPrinters": "All printers",
    "common.openOnly": "Open only",
    "production.syncOdoo": "Load from Odoo",
    "production.createOrder": "Create production order",
    "production.addOrder": "+ Production order",
    "production.noJobs": "No print jobs yet.",
    "production.printFile": "Print file",
    "production.multiplier": "Prints (multiplier)",
    "production.addRow": "+ Add row",
    "production.addToQueue": "Add to queue",
    "production.manualPrinting": "Manually set to Printing",
    "production.objectsPrints": "Objects / prints",
    "production.loadingFiles": "Loading files…",
    "production.loadError": "An unknown error occurred while loading",
    "production.createError": "Failed to create order: ",
    "production.createJobsError": "Failed to create print jobs: ",
    "production.validJobRequired": "At least one print job row must be valid.",
    "production.startError": "Failed to start print job.",
    "production.manualComment": "Comment for manual intervention (required):",
    "production.manualStartError": "Manual start failed: ",
    "production.manualCompleteError": "Manual completion failed: ",
    "production.cancelError": "Failed to cancel print job.",
    "production.batchNotes": "Batch notes (optional):",
    "production.completeError": "Failed to complete print job: ",
    "production.filesError": "Failed to load Bambuddy files",
    "production.bambuddyUrlMissing": "The public Bambuddy URL has not been configured.",
    "production.odooUnavailable": "Odoo is unavailable or not configured.",
    "production.odooImportError": "Could not import Odoo orders.",
    "production.odooTitle": "Odoo sync – production orders",
    "production.odooPreview": "Preview: Open Odoo orders are only loaded and displayed. Import new orders creates missing orders in the Hub; no print jobs are created.",
    "production.odooLoading": "Loading open production orders from Odoo…",
    "production.odooEmpty": "No open Odoo production orders found.",
    "production.odooReady": "ready to import",
    "production.odooProductMissing": "No matching Hub product",
    "production.odooImport": "Import new orders",
    "shipping.loadError": "Failed to load",
    "shipping.reopenError": "Could not reopen QA",
    "shipping.labelError": "Could not load label",
    "shipping.templateRequired": "Configure a labelprint template on the product or under Settings → Shipping.",
    "shipping.printConfirmed": "labelprint confirmed printing. The batch is marked as label printed.",
    "shipping.printSaveError": "Printing was confirmed, but the Hub status could not be saved. Retry saving the status only; closing this dialog loses the confirmation.",
    "shipping.odooRouteMissing": "The shipping Odoo route is not loaded in the running API service. Please restart the API container.",
    "shipping.odooLoadError": "Could not load Odoo orders",
    "shipping.odooReportError": "Reporting to Odoo failed",
    "shipping.enablePrinting": "Enable printing under Settings → Shipping. Displaying the QR code does not change the print status.",
    "shipping.wait": "Please wait…",
    "shipping.printed": "Printed",
    "shipping.retryStatus": "Retry saving status",
    "shipping.workflow": "Shipping workflow",
    "shipping.printAction": "Print label ({copies}×)",
    "shipping.qaSum": "The total must equal {expected} (currently {total})",
    "dashboard.cameras": "Cameras",
    "dashboard.system": "System status",
    "dashboard.containers": "Container information",
    "dashboard.containerDescription": "Runtime information for the active Nordlicht Hub API container.",
    "dashboard.environment": "Environment",
    "dashboard.uptime": "Uptime",
    "dashboard.runtime": "Runtime",
    "dashboard.service": "Service",
    "dashboard.hostname": "Hostname",
    "dashboard.version": "Version",
    "dashboard.apps": "Apps & tools",
    "dashboard.publicUrlMissing": "Public URL not configured yet",
    "dashboard.activities": "Recent activity",
    "dashboard.noActivities": "No activity yet.",
    "dashboard.cameraUnavailable": "Camera unavailable",
    "dashboard.now": "just now",
    "dashboard.minutesAgo": "{count} min ago",
    "dashboard.hoursAgo": "{count} h ago",
    "dashboard.daysAgo": "{count} days ago",
    "dashboard.cameraOpen": "Open {name}",
    "dashboard.databaseManagement": "Database management",
    "user.anonymous": "Not signed in",
    "user.settings": "Settings",
    "user.profile": "Manage profile",
    "user.appearance": "Appearance",
    "user.notifications": "Notifications",
    "user.cameras": "Dashboard cameras",
    "user.login": "Sign in",
    "user.logout": "Sign out",
    "user.menu": "User menu",
    "login.subtitle": "Secure production platform",
    "session.warning": "Your session is about to expire",
    "session.continue": "Keep working",
    "session.countdown": "Automatic sign-out due to inactivity in {time}.",
    "filters.close": "Close filters",
    "filters.advanced": "Advanced filters",
    "filters.active": "{count} active filters",
    "view.grid": "Grid view",
    "view.list": "List view",
    "version.showNotes": "Show release notes",
    "production.alreadyInHub": "already in Hub #{id}",
    "production.jobsForOrder": "Print jobs for order #{id}",
    "production.objectsPerPrint": "{count} objects per print",
    "production.fileId": "File {id}",
    "production.totalObjects": "Total: {count} objects in {jobs} print jobs",
    "production.orderSummary": "Order #{id} · Quantity {quantity} · done {done}",
    "status.FAILED": "Failed",
    "notifications.allRead": "Mark all read",
    "notifications.empty": "No new notifications",
    "notifications.open": "Open notification center",
    "settings.printTitle": "Label printing with labelprint",
    "settings.printEnable": "Enable desktop printing",
    "settings.printUrl": "Server URL",
    "settings.printTemplate": "Template (path from labelprint)",
    "settings.printPrinter": "Printer (optional: alias, address or model)",
    "settings.printDefault": "Template / desktop app default",
    "settings.printToken": "API token (only for this browser session)",
    "settings.printTokenHelp": "In labelprint under Extras → Settings, allow the Hub website and set an API token. Saving stores the token only in this browser tab. Server, general template and printer apply to the entire Hub.",
    "settings.printFieldsHelp": "Template fields: name (product), groesse (size), qr (batch link), lot (batch), gtin and pieces (quantity). Other template fields remain unchanged. Use Chrome, Edge or Firefox.",
    "settings.printReachable": "labelprint is reachable. No test label was printed.",
    "settings.testing": "Checking…",
    "settings.testConnection": "Test connection",
    "settings.startDesktop": "Start desktop app",
    "settings.saveFailed": "Saving failed",
    "printer.activeJob": "Active job",
    "printer.noJob": "No active print job",
    "printer.remaining": "Remaining",
    "printer.end": "End",
    "printer.start": "Start (estimated)",
    "printer.nozzle": "Nozzle",
    "printer.bed": "Print bed",
    "printer.days": "{count} days",
    "printer.today": "today {time}",
    "printer.tomorrow": "tomorrow {time}",
    "dashboard.appsError": "Could not load external applications.",
    "dashboard.spoolman": "Filaments and spools",
    "dashboard.bambuddy": "Printers and print jobs",
    "labelprint.invalidUrl": "Invalid labelprint server URL",
    "labelprint.unreachable": "labelprint is unreachable. Start the desktop app and check the server URL, allowed website and browser permission for the local network.",
    "labelprint.ambiguous": "No print confirmation received. Check the printer before retrying to avoid duplicate labels.",
    "labelprint.unconfirmed": "labelprint did not confirm printing. Check the printer before retrying.",
    "labelprint.http": "labelprint returned HTTP {status}. Check the token and allowed website.",
    "shipping.invalidLabelCount": "Enter a positive whole number of labels.",
    "shipping.goodPieces": "Batch good quantity",
    "shipping.labelTemplate": "Selected labelprint template",
    "shipping.labelCount": "Number of labels",
    "settings.printQuantityHelp": "The number of labels defaults to the batch good quantity and can be changed in the print dialog. A product template takes precedence over this general template.",
    "product.labelprintTemplate": "labelprint template (optional)",
    "product.labelprintTemplatePlaceholder": "General template from shipping settings",
    "product.labelprintTemplateHelp": "Path in the labelprint library, e.g. Ballons/Ballon Wilhelmine Gr. XL. Leave blank to use the general template."
  }
};

export function translate(locale, key, fallbackOrValues = key) {
  const values = typeof fallbackOrValues === "object" && fallbackOrValues !== null ? fallbackOrValues : {};
  const fallback = typeof fallbackOrValues === "string" ? fallbackOrValues : key;
  const message = translations[locale]?.[key] ?? translations.de[key] ?? fallback;
  return message.replace(/\{(\w+)\}/g, (match, name) => Object.hasOwn(values, name) ? String(values[name]) : match);
}
